import React from 'react';
import { connect } from 'react-redux';
import { OrderedMap } from 'immutable';
import ProductInPackingDisplayWrapper from
  '@/component/dict/complex/product/ProductInPackingDisplayWrapper';
import { getProductListWrapper } from
  '@/component/dict/complex/product/ProductWrapper';
import { getSimpleListWrapper }
  from '@/component/dict/simple/SimpleWrapper';
import { REF_PATH as productPath } from
  '@/component/dict/complex/product/Const';
import { REF_NAME as packingName, REF_PATH as packingPath } from
  '@/component/dict/simple/packing/Const';

import { getColor } from '../../../../util/util';

class ProductsViewer extends React.Component {
  constructor(props) {
    super(props);
    this.composeList = this.composeList.bind(this);
    this.getProduct = this.getProduct.bind(this);
    this.getProductName = this.getProductName.bind(this);
    this.getPackingName = this.getPackingName.bind(this);
    this.state = {
      products: [],
    };
  }

  componentWillMount() {
    this.composeList(this.props);
  }

  componentWillReceiveProps(props) {
    if (!props.products || props.products.size == 0) {
      getProductListWrapper();
    }
    if (!props.packing || props.packing.size == 0) {
      getSimpleListWrapper(packingName, packingPath);
    }
    this.composeList(props);
  }

  getProduct(props, productTypeId) {
    let product = undefined;
    if (props.products
      && props.products.size > 0) {
      props.products.forEach(prod => {
        const found = prod.get('productTypes')
          .find(ptype => ptype.get('id') == productTypeId);
        if (found != undefined) {
          product = prod;
        }
      });
    }
    return product;
  }

  getProductName(props, productTypeId) {
    let name = undefined;
    if (props.products
        && props.products.size > 0) {
      props.products.forEach(prod => {
        const found = prod.get('productTypes')
          .find(ptype => ptype.get('id') == productTypeId);
        if (found != undefined) {
          name = `${prod.get('name')}${found.get('name') == 'DEFAULTPRODUCTTTYPE'
            ? '' : ` / ${found.get('name')}`}`;
        }
      });
    }
    return name;
  }

  getPackingName(props, packingId) {
    let name = undefined;
    if (props.packing
      && props.packing.size > 0) {
      const found = props.packing.find(packing => packing.get('id') == packingId);
      if (found != undefined) {
        name = found.get('name');
      }
    }
    return name;
  }

  strcmp(a, b) {
    // eslint-disable-next-line
    return (a < b ? -1 : (a > b ? 1 : 0));
  }

  addDataToProducts(productTypeId, packingId, products, props) {
    const mapKey = `${productTypeId}:${packingId}`;
    if (!products.has(mapKey)) {
      const product = this.getProduct(props, productTypeId) || '';
      const productTypeName = this.getProductName(props, productTypeId) || '';
      const packageName = this.getPackingName(props, packingId) || '';
      const key = productTypeName + packageName;
      return products.set(
        mapKey,
        {
          key,
          product,
          productTypeId,
          packingId,
        });
    }
    return products;
  }

  composeList(props) {
    if (props.links
      && props.products
      && props.products.size > 0
      && props.packing
      && props.packing.size > 0) {
      let products = new OrderedMap();

      props.links.forEach((link) => {
        if (link.get('purchaseProductType')) {
          products = this.addDataToProducts(
            link.get('purchaseProductType'), link.get('purchasePacking'), products, props);
        }
        if (link.get('saleProductType')) {
          products = this.addDataToProducts(
            link.get('saleProductType'), link.get('salePacking'), products, props);
        }
      });
      products = products.sort((a, b) => this.strcmp(a.key, b.key));

      this.setState({ products: products.valueSeq().toJS() });
    }
  }

  render() {
    return (
      <div className={'product-viewer'}>
        {this.state.products ?
          this.state.products.map((elem, idx) =>
            <span key={elem.key}>
              {idx > 0 ? ' ' : ''}
              <ProductInPackingDisplayWrapper
                productTypeId={elem.productTypeId}
                packingId={elem.packingId}
                color={getColor(elem.product, elem.productTypeId)}
              />
            </span>)
          : ''
        }
      </div>
    );
  }
}

ProductsViewer.propTypes = {
  links: React.PropTypes.object,
  products: React.PropTypes.object,
  packing: React.PropTypes.object,
};

export default connect((state) => ({
  products: state.getIn(['references', 'complex', productPath]),
  packing: state.getIn(['references', 'simple', packingPath]),
}))(ProductsViewer);
